import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	min-height: 100vh;
	max-height: 100vh;
	background-color: ${color.interface.lightGray4};
	display: flex;
	/* background-color: yellow; */
	/* overflow: auto; */
`;

export const titleNavAndContent = styled.div`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	z-index: 0;
	padding: 0rem 2.4rem 2.4rem 2.4rem;
	overflow: auto;

	/* background-color: red; */

	::-webkit-scrollbar {
		width: 8px; /* width of the entire scrollbar */
		height: 4px;
	}

	@media (max-width: 1000px) {
		padding-top: 80px;
		/* padding-bottom: 5rem; */
	}
`;

// export const TitleNavAndContentStyled = styled(titleNavAndContent).withConfig({
// 	shouldForwardProp: (prop) => !['hidePadding'].includes(prop)
// })``;
